/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { alpha } from "@theme-ui/color"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import { Container, Row, Col } from "components/layout"

const SupportingEachotherHeroTwoFr = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "supporting-eachother-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box sx={{ mt: -4 }}>
      <BackgroundImage
        tag="div"
        fluid={data.hero.childImageSharp.fluid}
        backgroundColor="#fff"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: ["center", "center right"],
        }}
      >
        <Box
          sx={{
            backgroundColor: [
              alpha("secondary", 0.9),
              alpha("secondary", 0.9),
              alpha("secondary", 0),
            ],
            backgroundImage: [
              "none",
              "linear-gradient(to right, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.95) 40%, rgba(0,0,0,0) 65%)",
            ],
            color: "background",
            py: 4,
            width: "100%",
          }}
        >
          <Container wide>
            <Row>
              <Col sx={{ width: ["100%", "70%", "50%"] }}>
                <Styled.h1 sx={{ color: "background" }}>
                  Salut type 1, nous ne sommes pas seuls
                </Styled.h1>
                <Styled.p>Salut type 1, </Styled.p>
                <Styled.p>
                  Difficile d’imaginer qu’à un moment dans ma vie, je ne te
                  connaissais pas. À cause de ton arrivée inattendue, je sais
                  maintenant qui tu es, et plus que jamais, je connais tes
                  effets sur la communauté. Parce que j’en fais partie.
                </Styled.p>
                <Styled.p>
                  Tu t’es immiscé graduellement dans ma vie lorsque j’avais 26
                  ans et que je résidais à l’étranger loin de chez moi et de ma
                  famille. Ce n’est qu’après avoir réservé un vol pour retourner
                  à Calgary, avec presque 70 livres en moins, qu’on m’a
                  officiellement annoncé que j’étais aux prises avec toi pour le
                  reste de ma vie.
                </Styled.p>
                <Styled.p>
                  Aujourd’hui, âgé de 40 ans, je t’écris en tant que personne
                  qui a été bouleversée, et en colère, à cause de la façon dont
                  tu as changé ma vie, mais maintenant, je suis très motivé à ne
                  pas te laisser prendre le dessus.
                </Styled.p>
                <Styled.p>
                  Je suis constamment inspiré par les enfants atteints de DT1
                  qui sont si courageux et je ne peux imaginer être le parent de
                  l’un de ces enfants … c’est pourquoi une guérison est si
                  importante: aucun enfant et aucune famille ne devrait jamais
                  subir cela.
                </Styled.p>
              </Col>
            </Row>
          </Container>
        </Box>
      </BackgroundImage>
    </Box>
  )
}

export default SupportingEachotherHeroTwoFr
